// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WGle","col":"styles_col__3upel"};